import createStateReducer from "../../helpers/createStateReducer";
import states from "../../states/cohortModalType";
import deltas from "../../actions/deltas";

const {SET_COHORT_MODAL_TYPE_STATE} = deltas.actionTypes;

export default createStateReducer(states, states.EDIT, SET_COHORT_MODAL_TYPE_STATE);
